module.exports = __webpack_public_path__ + "assets/certified.ed061ce8e19bcdb3970d9fc4ceb20a62.svg";